import { render, staticRenderFns } from "./genre-pills.vue?vue&type=template&id=395422f0&scoped=true&"
import script from "./genre-pills.vue?vue&type=script&lang=js&"
export * from "./genre-pills.vue?vue&type=script&lang=js&"
import style0 from "./genre-pills.vue?vue&type=style&index=0&id=395422f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395422f0",
  null
  
)

export default component.exports